<template>
  <div class="company-validation-container">
    <b-loading is-full-page :active="loading.general" can-cancel></b-loading>

    <App-Titulo titulo="Cadastro" />

    <section
      v-if="
        (company.status === 'CADASTRADA' ||
          (company.status === 'PRIMEIRA_VALIDACAO' && !finishedTruthDeclaration)) &&
        loading.general === false
      "
      class="section"
    >
      <div class="columns">
        <div
          :class="
            companyRegisterStep === 0
              ? 'column is-8 is-offset-2'
              : 'column is-half is-offset-one-quarter'
          "
        >
          <b-message v-if="company.status === 'CADASTRADA'" type="is-warning" has-icon class="mb-4">
            Seu cadastro de empresa não foi concluído. Preencha os dados e envie a documentação para
            solicitar a validação e utilizar a plataforma.
          </b-message>

          <div class="bm-1">
            <b-steps
              animated
              :mobile-mode="null"
              :size="mobile ? 'is-small' : 'is-medium'"
              v-model="companyRegisterStep"
              :has-navigation="false"
            >
              <b-step-item clickable step="4" label="Dados da Empresa"> </b-step-item>
              <b-step-item clickable step="5" label="Documentos Requeridos"> </b-step-item>
              <b-step-item clickable step="6" label="Declaração de Veracidade"> </b-step-item>
            </b-steps>
          </div>

          <div
            v-if="lastValidation && lastValidation.status === 'INVALIDA'"
            class="box is-flex invalid-company-container"
          >
            <b-icon
              class="invalid-company-icon"
              icon="alert-box"
              size="is-large"
              type="is-warning"
            />
            <div class="invalid-company-text">
              <p>
                Infelizmente encontramos inconsistência(s) nos dados de sua empresa e a validação
                está pendente.
              </p>
              <p><strong>Motivo: </strong>{{ lastValidation.justificativa }}</p>
            </div>
          </div>

          <Company-Data-Register
            v-if="companyRegisterStep === 0 && company.status === 'CADASTRADA'"
          />
          <div
            v-if="companyRegisterStep === 1 && company.status === 'CADASTRADA'"
            class="send-documents-container"
          >
            <Company-Required-Documents :required-documents="requiredDocuments" />

            <Company-Send-Document :required-documents="requiredDocuments" />

            <b-field expanded class="mt-5">
              <button
                class="button is-primary is-fullwidth"
                :class="{ ' is-loading': loading.button }"
                :disabled="documentToSend"
                @click.prevent.stop="enviarDocumentosEAvancar()"
              >
                Enviar Documentos
              </button>
            </b-field>
          </div>

          <div
            v-if="companyRegisterStep === 2 && company.status === 'PRIMEIRA_VALIDACAO'"
            class="truth-declaration-container"
          >
            <div class="truth-declaration-content">
              <Company-Truth-Declaration
                :user="user"
                :company="company"
                :current-date-time="currentDateTime"
              />
            </div>

            <b-field expanded class="mt-5">
              <button
                class="button is-primary is-fullwidth"
                :class="{ ' is-loading': loading.buttonConfirm }"
                :disabled="disableRequestValidation"
                @click.prevent.stop="confirmarDeclaracao()"
              >
                Confirmar Declaração
              </button>
            </b-field>
          </div>
        </div>
      </div>
    </section>

    <div
      class="message-container"
      v-if="
        (company.status === 'PRIMEIRA_VALIDACAO' &&
          finishedTruthDeclaration &&
          loading.general === false) ||
        (company.status === 'HABILITADA' && loading.general === false)
      "
    >
      <div class="message-content">
        <AppMessage>
          <div slot="message-icon">
            <b-icon type="is-success" icon="check-circle-outline" size="is-large" />
          </div>

          <p slot="message-title">Cadastro Concluído!</p>

          <div slot="message">Agora é só acessar a Selcorp com seu login e senha. Aproveite!</div>
        </AppMessage>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import AppMessage from '@/components/AppMessage';
import AppTitulo from '@/components/AppTitulo';
import CompanyDataRegister from './CompanyDataRegister';
import CompanyRequiredDocuments from './CompanyRequiredDocuments';
import CompanySendDocument from './CompanySendDocument';
import CompanyTruthDeclaration from './CompanyTruthDeclaration';

export default {
  name: 'CompanyValidation',
  components: {
    AppMessage,
    AppTitulo,
    CompanyDataRegister,
    CompanyRequiredDocuments,
    CompanySendDocument,
    CompanyTruthDeclaration,
  },
  data() {
    const loading = {
      button: false,
      buttonConfirm: false,
      general: false,
    };

    return {
      companyRegisterStep: 0,
      loading,
      finishedTruthDeclaration: false,
      currentDateTime: new Date().toLocaleString('pt-BR'),
    };
  },
  watch: {
    company: {
      deep: true,
      handler() {
        if (this.company.status === 'HABILITADA') {
          // Mantém na tela de sucesso se já estiver habilitada ou redireciona
          // Dependendo da regra de negócio, pode deixar na mensagem de sucesso
        }

        if (this.company.status === 'PRIMEIRA_VALIDACAO' && !this.finishedTruthDeclaration) {
          this.companyRegisterStep = 2;
        }
      },
    },
  },
  computed: {
    ...mapState('app', ['windowWidth']),
    ...mapState('companies', ['company']),
    ...mapState('companiesDocuments', ['companyDocuments', 'companyUpload']),
    ...mapState('documentTypes', ['documentTypes']),
    ...mapGetters('app', { mobile: 'mobile' }),
    ...mapGetters({
      lastValidation: 'lastValidation',
      user: 'getUser',
    }),
    disableRequestValidation() {
      if (this.documentToSend) return true;
      if (!this.company.activity) return true;
      if (!this.company.address) return true;
      if (!this.company.city) return true;
      if (!this.company.cnpj) return true;
      if (!this.company.companySize) return true;
      if (!this.company.email) return true;
      if (!this.company.fantasyName) return true;
      if (!this.company.legalNature) return true;
      if (!this.company.IBGECode) return true;
      if (!this.company.municipalRegistration) return true;
      if (!this.company.neighborhood) return true;
      if (!this.company.number) return true;
      if (!this.company.shareCapital) return true;
      if (!this.company.telephone) return true;
      if (!this.company.billingCellphone) return true;
      if (!this.company.socialDenomination) return true;
      if (!this.company.state) return true;
      if (!this.company.zipCode) return true;

      return false;
    },
    documentToSend() {
      const requiredTypes = this.requiredDocuments.map(element => element.type);
      const companyTypes = this.companyDocuments.map(element => element.type);

      return requiredTypes.some(requiredType => !companyTypes.includes(requiredType));
    },
    requiredDocuments() {
      return this.documentTypes.filter(documentType => documentType.register);
    },
  },
  methods: {
    ...mapActions('companies', ['fetchCompany', 'acceptCompantTruthDeclaration']),
    ...mapActions('companiesDocuments', ['fetchCompanyDocuments']),
    ...mapActions('documentTypes', ['fetchDocumentTypes']),
    ...mapActions([
      'fetchUser',
      'fetchLastValidation',
      'solicitarValidacaoEmpresa',
      'validarEmpresa',
    ]),
    async enviarDocumentosEAvancar() {
      this.loading.button = true;
      try {
        await this.solicitarValidacaoEmpresa(this.company.id);
        await Promise.all([this.fetchCompany(this.company.id), this.fetchUser(this.user.id)]);
        this.$alerta('Documentos enviados com sucesso.', 'is-success');
        this.companyRegisterStep = 2;
      } catch (error) {
        this.$alerta('Erro ao solicitar validação da empresa', 'is-danger');
      }
      this.loading.button = false;
    },
    async confirmarDeclaracao() {
      this.loading.buttonConfirm = true;
      try {
        const data = {
          status: 'VALIDA',
          justificativa: 'Declaração de veracidade confirmada pelo usuário.',
        };

        // Detectar o ID da validação de forma mais robusta
        let validationId = null;

        if (this.lastValidation && this.lastValidation.id) {
          validationId = this.lastValidation.id;
        } else if (this.$store.state.empresasPendentes.empresaValidacao) {
          const { empresaValidacao } = this.$store.state.empresasPendentes;
          if (Array.isArray(empresaValidacao)) {
            const pending = empresaValidacao.find(v => v.status === 'PENDENTE');
            validationId = pending?.id ?? empresaValidacao[0]?.id ?? null;
          } else if (empresaValidacao.id) {
            validationId = empresaValidacao.id;
          }
        }

        if (!validationId) {
          throw new Error('ID de validação não encontrado.');
        }

        // Garante que o ID esteja no lugar esperado pela action do store
        this.$store.state.empresasPendentes.empresaValidacao = { id: validationId };

        await this.acceptCompantTruthDeclaration({ companyId: this.company.id });
        await this.validarEmpresa(data);
        this.$alerta('Declaração confirmada!', 'is-success');
        this.finishedTruthDeclaration = true;
        await this.fetchCompany(this.company.id);
      } catch (error) {
        this.$alerta('Erro ao confirmar declaração', 'is-danger');
      }
      this.loading.buttonConfirm = false;
    },
    async loadData() {
      this.loading.general = true;
      try {
        await Promise.all([
          this.fetchDocumentTypes(),
          this.fetchCompany(this.company.id),
          this.fetchCompanyDocuments(this.company.id),
          this.fetchLastValidation(this.company.id),
        ]);
      } catch (error) {
        this.$alerta('Erro ao buscar dados', 'is-danger');
      } finally {
        this.loading.general = false;
      }
    },
  },
  async created() {
    if (this.company.contractAccepted) {
      this.loadData();
    } else {
      this.$router.push({ name: 'Register' });
    }
  },
  mounted() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);
  },
};
</script>

<style lang="scss" scoped>
.truth-declaration-container {
  margin-bottom: 2rem;
}

.truth-declaration-content {
  background-color: white;
}

.message-container {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 55vh;
}

.message-content {
  margin: 0 10px;
  max-width: 710px;
}

.message-title {
  margin-top: 1rem;
}

.invalid-company-container {
  align-items: center;
  margin-bottom: 3rem;
}

.invalid-company-icon {
  margin-right: 1rem;
}

@media (max-width: 769px) {
  .invalid-company-text {
    font-size: 0.9rem;
  }
}
.pricing-table {
  display: flex;
  gap: 20px;
  justify-content: center;
}
.pricing-plan {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  padding: 20px;
  text-align: center;
  width: 280px;
  transition: transform 0.3s;
}
.pricing-plan:hover {
  transform: scale(1.05);
}
.pricing-plan.featured {
  border: 2px solid #007bff;
}
.pricing-plan.premium {
  background-color: #f0f0f0;
  color: #666;
}
.plan-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}
.plan-price {
  font-size: 36px;
  font-weight: bold;
  margin: 10px 0;
}
.plan-duration {
  font-size: 16px;
  color: gray;
  margin-bottom: 20px;
}
.plan-features {
  list-style-type: none;
  padding: 0;
  margin-bottom: 20px;
}
.plan-features li {
  margin-bottom: 10px;
}
.sign-up-btn {
  display: inline-block;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  text-decoration: none;
  font-weight: bold;
  cursor: pointer;
}
.sign-up-btn:hover {
  background-color: #0056b3;
}
.sign-up-btn.premium-btn {
  background-color: #666;
}
.sign-up-btn.premium-btn:hover {
  background-color: #444;
}
select {
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 16px;
}
</style>
